/**
 * @author xyguo
 * @description 新开业培训要求记录管理
 * @Date 2021/3/16
 */
import React from 'react';
import {connect} from 'dva';
import {templateConfig, reduxTemplateCofig} from './config';
import {baseExcelColumns,dpTrainExcelColumns,dpTrainBExcelColumns} from "./excelColumns";

import {framework_tool, component_tool, utils_tool} from '@/tool'

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizCol, WizRow,WizModal} = component_tool;
let {checkStrLength, Session} = utils_tool;
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterType = (val) => {
  let newVal;
  switch (val) {
    case  1 :
      newVal = '经销商'
      break;
    case  2 :
      newVal = '服务商'
      break;
    case 99:
      newVal = '暂定'
      break;
    default :
      newVal = '无';
  }
  return newVal;
}

const formatterState = (val) => {
  if(val == null || val == undefined || val == -1){
    return "";
  }
  let newVal;
  switch (val) {
    case 0 :
      newVal = "● 合格"
      break;
    case 1 :
      newVal = "● 不合格"
      break;
    case 3 :
      newVal = "○"
      break;
    case 4 :
      newVal = ""
      break;
  }
  return newVal;
}


class RequirementPersonnelDetailList extends WizContainer {

  componentName = 'RequirementPersonnelDetailList';

  constructor(props) {
    super(props);
    let initialValue={}
    const {history} = props;
    if (history.location.record) {
      history.location.record.typeName = formatterType(history.location.record.dealerType);
      Session.set('dealerNewPersonTrainDetail', history.location.record);
      initialValue = history.location.record;
    } else if (Session.get('dealerNewPersonTrainDetail')) {
      initialValue = Session.get('dealerNewPersonTrainDetail') ? Session.get('dealerNewPersonTrainDetail') : {};
    }
    this.state = {
      trainState: initialValue.state,
      scoreVisable: false,
      lookRecord:{},
    }
    this.initialValue = initialValue;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      location.reload();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    let columnDefs =  [...baseExcelColumns];
    if (o['success']) {
      let data = o['data']
      let record = Session.get('dealerNewPersonTrainDetail') ? Session.get('dealerNewPersonTrainDetail') : {};
      let title = '经销商名称：' + record.name + '\n'
        + '品牌：' + record.brandName + '\n'
        + '站点类型：' + record.typeName +'\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '预估开业时间：' + formatterDate(record.estimateOpenTime) + '\n'
        + '开店时间：' + formatterDate(record.openTime) + '\n';

      WizBrowserExport({
        title: title,
        sheetName: '新人培训详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新人培训详情.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 115
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFileExport=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data']
      let headList = data.headList
      let dataList = data.dataList
      let columnDefs =  [...dpTrainExcelColumns(headList)];
      let record = Session.get('dealerNewPersonTrainDetail') ? Session.get('dealerNewPersonTrainDetail') : {};
      let title = '经销商名称：' + record.name + '\n'
        + '品牌：' + record.brandName + '\n'
        + '站点类型：' + record.typeName +'\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '预估开业时间：' + formatterDate(record.estimateOpenTime) + '\n'
        + '开店时间：' + formatterDate(record.openTime) + '\n';

      WizBrowserExport({
        title: title,
        sheetName: '新人培训详情实际培训情况',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '新人培训详情实际培训情况.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 115
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFileDpExport=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data']
      let headList = data.headList
      let dataList = data.dataList
      let columnDefs =  [...dpTrainExcelColumns(headList)];
      let record = Session.get('dealerNewPersonTrainDetail') ? Session.get('dealerNewPersonTrainDetail') : {};
      let title = '经销商名称：' + record.name + '\n'
        + '品牌：' + record.brandName + '\n'
        + '站点类型：' + record.typeName +'\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '预估开业时间：' + formatterDate(record.estimateOpenTime) + '\n'
        + '开店时间：' + formatterDate(record.openTime) + '\n';

      WizBrowserExport({
        title: title,
        sheetName: '新人培训详情DP培训情况',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '新人培训详情DP培训情况.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 115
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFileBExport=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data']
      let headList = data.headList
      let dataList = data.dataList
      let columnDefs =  [...dpTrainBExcelColumns(headList)];
      let record = Session.get('dealerNewPersonTrainDetail') ? Session.get('dealerNewPersonTrainDetail') : {};
      let title = '经销商名称：' + record.name + '\n'
        + '品牌：' + record.brandName + '\n'
        + '站点类型：' + record.typeName +'\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '预估开业时间：' + formatterDate(record.estimateOpenTime) + '\n'
        + '开店时间：' + formatterDate(record.openTime) + '\n';

      WizBrowserExport({
        title: title,
        sheetName: '新人培训详情培训B表情况',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '新人培训详情培训B表情况.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 115
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _showTitle(record) {
    let content = <WizCard title={'经销商信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={8} offset={2}>
          经销商名称: {record.name}
        </WizCol>
        <WizCol span={6}>
          品牌: {record.brandName}
        </WizCol>
        <WizCol span={8}>
          站点类型: {record.typeName}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          销售代码: {record.preSalesNumber}
        </WizCol>
        <WizCol span={6}>
          售后代码: {record.afterSalesNumber}
        </WizCol>
        <WizCol span={8}>
          预估开业时间: {formatterDate(record.estimateOpenTime)}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          开店时间: {formatterDate(record.openTime)}
        </WizCol>
        <WizCol>
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _render() {
    let record = this.initialValue;
    const {type,isNew} = record;
    let _reduxTemplateCofig = reduxTemplateCofig({
      record,
      templateConfig: templateConfig(this.state.trainState, type,isNew,this,record),
      apiDataFormat: {
        export: this._handleFile,
        exportRealTrain: this._handleFileExport,
        exportDpTrain: this._handleFileDpExport,
        exportBTrain: this._handleFileBExport,
        setOldDealerNewPerson: this._handleCMD,
      },
      keepInitApiParams: true,
    })
    return <>{this._showTitle(record)}
      <WizCard title={'新人培训详情'}>
        <WizReduxTemplate {..._reduxTemplateCofig} style={{paddingTop: "100px"}}/>
        <WizModal visible={this.state.scoreVisable} footer={null}
           onOk={()=>this.setState({
            scoreVisable:false
           })}
           onCancel={()=>this.setState({
            scoreVisable:false
           })}
          >
        </WizModal>
      </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementPersonnelDetailList);
